export const LANGUAGES = {
    en: 'en',
    fr: 'fr'
}
export const DEFAULT_LANGUAGE = LANGUAGES.en;